import {} from "viem";
import { defaultFeeEstimator } from "./defaults/feeEstimator.js";
import { defaultGasEstimator } from "./defaults/gasEstimator.js";
import { defaultPaymasterAndData } from "./defaults/paymasterAndData.js";
import { defaultUserOpSigner } from "./defaults/userOpSigner.js";
import { noopMiddleware } from "./noopMiddleware.js";
/**
 * function that takes in ClientMiddlewareConfig used during client initiation
 * and returns the middleware actions object that the smart account client extends with
 *
 * @param {ClientMiddlewareConfig} overrides config used during client initiation for overriding default middlewares
 * @returns {(client: MiddlewareClient<TTransport, TChain, TAccount>) => { middleware: ClientMiddleware }} middleware actions object
 */
export const middlewareActions = (overrides) => (client) => ({
    middleware: {
        customMiddleware: overrides.customMiddleware ?? noopMiddleware,
        dummyPaymasterAndData: overrides.dummyPaymasterAndData ?? defaultPaymasterAndData,
        feeEstimator: overrides.feeEstimator ?? defaultFeeEstimator(client),
        gasEstimator: overrides.gasEstimator ?? defaultGasEstimator(client),
        paymasterAndData: overrides.paymasterAndData ?? defaultPaymasterAndData,
        userOperationSimulator: overrides.userOperationSimulator ?? noopMiddleware,
        signUserOperation: overrides.signUserOperation ?? defaultUserOpSigner,
    },
});
//# sourceMappingURL=actions.js.map